import { TextField, WithStyles } from "@material-ui/core";
import * as React from "react";
import { useState } from "react";
import { styles } from "./FormDateField.styles";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import { DATE_FORMAT } from "../../../constants/TIME";

export interface IFormDateField extends WithStyles<typeof styles> {
    id?: string;
    variant?: "outlined" | "filled";
    placeholder: string;
    disabled: boolean;
    label?: string;
    value: string;
    firstAvailableDate?: string;
    lastAvailableDate?: string;
    onChange: any;
    error?: boolean;
    helperText?: string;
    allowFuture?: boolean;
    fullWidth?: boolean;
}

const FormDateFieldPure: React.FunctionComponent<IFormDateField> = ({
    id,
    variant,
    placeholder,
    label,
    disabled,
    value,
    firstAvailableDate,
    lastAvailableDate,
    onChange,
    error,
    helperText,
    allowFuture,
    fullWidth,
    classes
}: IFormDateField) => {
    const [internalValue, setInternalValue] = useState(value);

    function onChangeInternal(value) {
        const momentDate = moment(value, DATE_FORMAT);
        if (momentDate.isValid()) {
            onChange(value);
        }
        setInternalValue(value);
    }

    const minDate = firstAvailableDate || undefined;
    const maxDate = allowFuture ? undefined : lastAvailableDate || moment().format(DATE_FORMAT);
    const inputProps = {
        max: maxDate,
        min: minDate
    };

    const isOutlined = !variant || variant === "outlined";

    return (
        <TextField
            label={!isOutlined && label}
            id={id || "date"}
            variant={variant || "outlined"}
            placeholder={placeholder}
            type="date"
            disabled={disabled}
            error={error}
            helperText={helperText}
            value={internalValue}
            onChange={event => onChangeInternal(event.target.value)}
            onBlur={event => onChange(internalValue)}
            className={isOutlined ? classes.outlined : classes.filled}
            InputProps={{ inputProps }}
            InputLabelProps={{
                shrink: true
            }}
            fullWidth={fullWidth}
        />
    );
};

export const FormDateField = withStyles(styles)(FormDateFieldPure);
